import { AccessControlProvider } from "@refinedev/core";
import { fetchMe } from "./me";
import {
  ADMIN_SECTION_ROUTE,
  cleanRoute,
  isSectionOrChildAllowed,
} from "./sections";

/**
 * Гейтинг разделов CMS (только фронт, по решению задачи 9685):
 * - супер-админ видит только «Пользователи и роли»;
 * - оператор видит разделы своей роли;
 * - /cms/me недоступен (старый бэк) — fail-open, ничего не прячем,
 *   кроме админского раздела.
 */
export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, params }) => {
    const paramsResource = params?.resource as
      | { route?: string; list?: unknown }
      | undefined;
    const route = cleanRoute(
      paramsResource?.route ??
        (typeof paramsResource?.list === "string"
          ? paramsResource.list
          : undefined)
    );
    const isAdminSection =
      resource === "admin-access" ||
      (route ? route.startsWith(ADMIN_SECTION_ROUTE) : false);

    let me;
    try {
      me = await fetchMe();
    } catch {
      // Бэк без /cms/me — поведение как раньше, админ-раздел скрыт.
      return { can: !isAdminSection };
    }

    if (isAdminSection) {
      return { can: me.isAdmin };
    }
    if (me.isAdmin) {
      // Супер-админ видит все разделы.
      return { can: true };
    }
    if (!route) {
      // Контейнеры/элементы без роута решает фильтрация в сайдбаре.
      return { can: true };
    }
    return { can: isSectionOrChildAllowed(route, me.allowedSections) };
  },
};
